import axios from 'axios';

import { PAYMENT_API_URI, CART_API_URI } from '@constants';
import { retrieveAccessToken } from '@utils';

const paymentsUrl = apiMethod =>
  `${PAYMENT_API_URI}/api/v1/payments/${apiMethod}`;
const cartCheckoutUrl = () => `${CART_API_URI}/api/v1/checkout/cart`;

export const submitPayment = async payload => {
  const { data } = await axios.post(paymentsUrl('submitted'), payload, {
    headers: {
      Authorization: `Bearer ${retrieveAccessToken()}`,
    },
  });
  if (data.statusCode !== 201) {
    console.error('Payment submission failed', data);
  }
  return data.data;
};

export const capturePayment = async (transactionId, amount) => {
  const { data } = await axios.post(
    paymentsUrl('capture'),
    { totalAmount: amount / 100 },
    {
      params: { transactionId },
      headers: {
        Authorization: `Bearer ${retrieveAccessToken()}`,
      },
    }
  );
  return data;
};

export const cartCheckout = async (orderId, transactionId) => {
  const { data } = await axios.post(
    cartCheckoutUrl(),
    {
      orderId,
      paymentStatus: 'requires_capture',
      paymentTransactionId: transactionId,
      preferredLanguage: 'en',
      checkoutFlow: 'VEHICLE_PAYMENT',
      customer: { email: '' },
    },
    {
      headers: {
        Authorization: `Bearer ${retrieveAccessToken()}`,
      },
    }
  );
  return data?.data || data;
};

export const getPaymentConfig = async (market, channel) => {
  const { data } = await axios.get(
    `${paymentsUrl('config')}?market=${market}&channel=${channel}`,
    {
      headers: {
        Authorization: `Bearer ${retrieveAccessToken()}`,
      },
    }
  );

  return data;
};
